"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Mail } from "lucide-react";
export default function ContactCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <div ref={ref} className={`
            text-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
          `}>
          <div className="mb-6">
            <Mail className="size-12 mx-auto text-primary mb-4" />
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-3">
              Ready to Elevate Your Project?
            </h2>
            <p className="text-muted-foreground text-lg max-w-xl mx-auto">
              Get precise aerial data, thermal imaging, and expert drone services for Central Texas and DFW Metroplex.
            </p>
          </div>

          <Link to="/ContactPage">
            <Button size="lg" className="
                transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]
                hover:scale-[1.02] hover:shadow-medium
                active:scale-100
              ">
              <Mail className="size-5" />
              Get in Touch
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}